<script>
    import { metaInfo } from "@/core/MetaInfo";
    import { brandHistory } from "@xd/brand-history";
    import BrandHero from "@xd/components/brand/BrandHero";
    import BrandMobileNavigation from "@xd/components/brand/BrandMobileNavigation";
    import BrandTimeline from "@xd/components/brand/BrandTimeline";
    import BrandProduct from "@xd/components/brand/BrandProduct";
    import BrandFooter from "@xd/components/brand/BrandFooter";

    export default {
        name: "BrandHistory",
        components: {
            BrandMobileNavigation,
            BrandHero,
            BrandTimeline,
            BrandProduct,
            BrandFooter,
        },
        computed: {
            products() {
                return brandHistory.products;
            },
        },
        metaInfo() {
            return metaInfo.getMeta("about");
        },
    };
</script>

<template>
    <div class="brand-history">
        <div class="brand-history__hero">
            <brand-hero></brand-hero>
        </div>

        <div class="brand-history__mobile-navigation">
            <brand-mobile-navigation></brand-mobile-navigation>
        </div>

        <div class="brand-history__wrapper">
            <div class="brand-history__timeline">
                <brand-timeline></brand-timeline>
            </div>

            <div class="brand-history__products">
                <brand-product
                    v-for="(product, index) in products"
                    :product="product"
                    :index="index"
                    :key="index"
                ></brand-product>
            </div>
        </div>

        <div class="brand-history__footer">
            <brand-footer></brand-footer>
        </div>
    </div>
</template>

<style lang="scss">
    .brand-history__hero {
        position: relative;
        z-index: 4;
    }

    .brand-history__mobile-navigation {
        @include sticky(46px);
        z-index: 3;
        @include bp($bp-desktop-lg) {
            display: none;
        }
    }

    .brand-history__timeline {
        display: none;
        @include bp($bp-desktop-lg) {
            @include sticky(55px);
            z-index: 3;
            display: block;
        }
    }

    .brand-history__wrapper {
        position: relative;
    }

    .brand-history__products {
        overflow: hidden;
    }

    @keyframes levitation {
        0%,
        100% {
            transform: translateY(0px);
        }
        50% {
            transform: translateY(-15px);
        }
    }
</style>
